export default "__VITE_ASSET__BPA5ItK___"